export default "/storefront/client/images/live-event-ocean-banner.png";